import { render, staticRenderFns } from "./TeleMarketAssign.vue?vue&type=template&id=778c105d&scoped=true&"
import script from "./TeleMarketAssign.vue?vue&type=script&lang=js&"
export * from "./TeleMarketAssign.vue?vue&type=script&lang=js&"
import style0 from "./TeleMarketAssign.vue?vue&type=style&index=0&id=778c105d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778c105d",
  null
  
)

export default component.exports